import { render, staticRenderFns } from "./Watchdetail.vue?vue&type=template&id=763028ee&scoped=true"
import script from "./Watchdetail.vue?vue&type=script&lang=js"
export * from "./Watchdetail.vue?vue&type=script&lang=js"
import style0 from "./Watchdetail.vue?vue&type=style&index=0&id=763028ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763028ee",
  null
  
)

export default component.exports